import { INTERNAL_OPS_CUSTOM_TYPES } from "@/lib/constants";
import type { MentorWorkspaceId } from "./workspace";

const TEEN_CUSTOM_TYPES = ["MENTORSHIP"] as const;

export type NoticeViewKind = "flat" | "grouped";

export interface NoticeWorkspaceBehavior {
  id: MentorWorkspaceId;
  customTypesFilter: string[];
  fetchesMentorshipSignals: boolean;
  fetchesInternalOps: boolean;
  computesNeedsResponse: boolean;
  view: NoticeViewKind;
}

const NOTICE_WORKSPACE_BEHAVIORS: Record<
  MentorWorkspaceId,
  NoticeWorkspaceBehavior
> = {
  teens: {
    id: "teens",
    customTypesFilter: [...TEEN_CUSTOM_TYPES],
    fetchesMentorshipSignals: true,
    fetchesInternalOps: false,
    computesNeedsResponse: true,
    view: "flat",
  },
  support: {
    id: "support",
    customTypesFilter: [...INTERNAL_OPS_CUSTOM_TYPES],
    fetchesMentorshipSignals: false,
    fetchesInternalOps: true,
    computesNeedsResponse: false,
    view: "grouped",
  },
};

export function getNoticeWorkspaceBehavior(
  workspace: MentorWorkspaceId,
): NoticeWorkspaceBehavior {
  return NOTICE_WORKSPACE_BEHAVIORS[workspace];
}
